import PersonalProfile from "./personal_profile";

export default PersonalProfile;
